import { render, staticRenderFns } from "./task-list-change-priority.vue?vue&type=template&id=53d3fab4&scoped=true"
import script from "./task-list-change-priority.vue?vue&type=script&lang=js"
export * from "./task-list-change-priority.vue?vue&type=script&lang=js"
import style0 from "./task-list-change-priority.vue?vue&type=style&index=0&id=53d3fab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3fab4",
  null
  
)

export default component.exports